/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import { VERB_ORGANIZE_INSERT } from "constants/enums";
import AddIcon from "@spectrum-icons/workflow/AddCircle";
import * as constants from "constants/constants";
import * as stores from "stores";
import { providers } from "dc-core";
import { handleInsertClick, getSupportedFileTypes } from "./utils/OrganizeUtils";

class OrganizeInsertBootstrap extends Component {
  getLabel = () => {};

  getIcon = () => AddIcon;

  getTooltip = () => getMessage("tooltip.insertPdf");

  getAriaLabel = () => getMessage("arialabel.insertPdf");

  getTooltipPlacement = () => "right";

  getLimitNames = () => ({
    process: []
  });

  supportedDroppedFileTypes = () => getSupportedFileTypes();

  supportedFileTypes = () => getSupportedFileTypes();

  getUpsellParams = () => ({ shouldUpsell: false });

  getTooltipDelay = () => constants.TOOLTIP_DELAY;

  id = VERB_ORGANIZE_INSERT;

  initializeAction = () => {};

  executeAction = async (opts = {}) => {
    const editProvider = await providers["edit-provider"]();
    await editProvider?.loadEditModule();
    if (opts && opts.pageIndex >= 0) {
      await handleInsertClick(stores, opts.pageIndex);
    }
  };

  render() {
    return null;
  }
}

export default OrganizeInsertBootstrap;
